import {uploadEvent} from '@/api/system'
import router from '@/router'
import Vue from 'vue'
const plugin = {
  install: (Vue, options) => {
    function upload(params) {
      return new Promise(function(resolve, reject){
        reject("cancel")
        return
        let referer = document.referrer
        if (referer) {
          // 添加来源
          params.referer = referer
        }
        let source = router.history.current.query.source
        if (source) {
          params.source = source
        }

        // 添加屏幕尺寸信息
        let screen = window.screen.width+','+window.screen.height
        params.screen_size = screen

        // !!!降低服务器压力
        // resolve()
        uploadEvent(params)
        .then((res) => {
          if (res.code == 1) {
            resolve(res)
          } else {
            reject(res)
          }
        }).catch((e) => {
          console.log('统计上传失败',params,e)
          reject(e)
        })
      });
    }
    const Event = {
      page (title, path, name) {
        return new Promise(function(resolve, reject){
          let fullPath = process.env.WEB_ORIGIN + path
          var params = {
            type: 'page',
            title: title,
            url: fullPath,
            data: name
          }
          upload(params)
          .then((res) => {
            resolve(res)
          }).catch((e) => {
            reject(e)
          })
        });
      },
      bd_page (name, params, query) {
        const blur_query_key = ['refer', 'invitor', 'u', 'comment', 'submit_comment', 'post_id', 'class_id', 'token', 'name', 'query', 'object_id', 'class', 'reuse_punch_in', 'url', 'join_id', 'continueFlag', 'redirect', 'ask_comment', 'draft', 'ids', 'file_name', 'cycle', 'tid', 'copy_id', 'title', 'order', 'status']
        const special_value_key = {
          'template': ['invite']
        }
        const filter_query_key = ['share_user', 'submit', 'student_id', 'pst', 'student_name', 't', 'reload', 'isappinstalled', 'scene', 'clicktime', 'enterid', 'scope', 'create_success', 'rank_popup', 'flower_popup', 'has_next']
        let p = {}
        for (const key in params) {
          if (Object.hasOwnProperty.call(params, key)) {
            p[key] = key
          }
        }
        let q = {}
        // 暂时先去掉所有query统计
        // for (const key in query) {
        //   if (Object.hasOwnProperty.call(query, key)) {
        //     if (!Object.hasOwnProperty.call(q, key)) {
        //       if (filter_query_key.indexOf(key) >= 0) {   //如果是过滤字段，则不添加

        //       } else if (Object.hasOwnProperty.call(special_value_key, key) &&
        //                  special_value_key[key].length > 0 &&
        //                  special_value_key[key].indexOf(query[key]) >= 0) {   // 如果是特定值的query字段，则添加原来的键值对
        //         q[key] = query[key]
        //       } else if (blur_query_key.indexOf(key) >= 0) {      // 如果是模糊信息字段，则直接设置值为键名
        //         q[key] = key
        //       } else {        // 不在以上情况中则添加原来的键值对
        //         q[key] = query[key]
        //       }
        //     }
        //   }
        // }
        const redirect = router.resolve({
          name: name,
          params: p,
          query: q
        })
        let path = redirect.href
        console.log('页面事件统计', path)
        Vue.$baidu.page(path)
      },
      event (key, value, data) {
        return new Promise(function(resolve, reject){
          const path = router.history.current.fullPath
          let url = process.env.WEB_ORIGIN + path
          const title = router.history.current.meta.title
          var params = {
            type: 'event',
            event_key: key,
            event_value: value,
            title: title,
            url: url,
            data: data?data:''
          }
          upload(params)
          .then((res) => {
            resolve(res)
          }).catch((e) => {
            reject(e)
          })
        });
      },
      click (value, data) {
        return new Promise((resolve, reject) => {
          this.event('click',value, data)
          .then((res) => {
            resolve(true, res)
          }).catch((e) => {
            // console.log('click reject',e)
            resolve(false, e)
          })
        });
      }
    }

    // 添加到全局
    window.$eventAnalyse = Vue.$eventAnalyse = Event
    // 添加到实例
    Vue.prototype.$eventAnalyse = Event

    /**
     * 通过在dom上放入data-event属性来发送event
     *
     * 举例：
     * <a href="xx" data-event="类别|操作|label|value"></a>
     * 即会触发：_hmt.push(['_trackEvent','类别','操作', 'label', 'value'])
     */
    document.body.addEventListener('click', (event) => {
      let target = event.target
      let datastr = target.getAttribute('data-event')

      if (!datastr && target.parentNode) {
        target = target.parentNode
        datastr = target.getAttribute('data-event')

        if (!datastr && target.parentNode) {
          target = target.parentNode
          if (target.getAttribute) {
            datastr = target.getAttribute('data-event')
          }
        }
      }

      if (datastr) {
        Event.click(datastr)
      }

    }, false)
  }
}

export default plugin



// WEBPACK FOOTER //
// ./src/plugins/EventAnalysis.js